<div class="bg-white placeholder-content-item me-2 rounded-1" [style.height.px]="height" [style.width.px]="width"></div>